module.exports = __webpack_public_path__ + "img/img-magic-4-b-03-img.d8f13fa0.png";